<template>
    <div>
        <div v-bind:class="wrapClass">
      <span class="input-group-addon" v-if="!isVertical && label && label.length>0">
            <i class="zmdi" v-bind:class="icon" v-if="hasIcon"></i><span class="gray" v-bind:class="{'p-10':hasIcon}">{{label}}</span>
      </span>
            <div class="fg-line" v-bind:class="{'fg-toggled':(ifocus||(hasValue && isVertical))}">
                <input type='text' class="form-control date-picker" v-bind:value="showValue" v-bind:placeholder="placeholder" v-on:focus="_p_focus"
                       v-on:blur="_p_blur" v-on:click="_p_click" v-bind:disabled="!isEnabled" />
                <label v-if="isVertical" class="fg-label">{{label}}</label>
            </div>
            <div v-if="validator">
                <span class="zmdi zmdi-alert-triangle form-control-feedback" v-show="!Valid_Status__" data-placement="bottom" style="width:5px;"></span>
                <span class="zmdi zmdi-check form-control-feedback" v-if="Valid_Status__&&hasValueL"
                      style="width:5px;"></span>
            </div>
        </div>
    </div>
</template>
<script>

    import moment from 'moment';
    //import zh_cn from 'momentzhcn'
    import valid from '../../mixins/control-valid';
    import mixins from '../../mixins/control-mixins';
    import 'bootstrap-datetimepicker';


    var data = function () {
        return {
            ifocus: false,
            myValue: this.value
        };
    };

    export default {
        name: 'c-datepicker',
        mixins: [mixins, valid],
        data: data,
        computed: {
            showValue: {
                get: function () {
                    var self = this;
                    return self.myValue;
                },
                set: function (val) {
                    var self = this;
                    if (self.showValue === val)
                        return;
                    if (val === null || val === undefined || val.length === 0) {
                        self.myValue = '';
                        return;
                    }
                    self.myValue = val;
                }
            },
            wrapClass() {
                return {
                    'form-group fg-float m-t-20':this.isVertical ,
                    'input-group':!this.isVertical ,
                    'disabled': !this.isEnabled ,
                    'has-warning':this.validator && !this.Valid_Status__,
                    'has-success':this.validator && this.Valid_Status__ && this.value!==null && this.value!==undefined && this.value.length>0
                }
            },
            hasIcon(){
                return this.icon.length>0;
            },
            hasValue(){
                return this.value && this.value.length>0;
            },
            hasValueL(){
                return this.value!==null && this.value!==undefined && this.value.length>0;
            }
        },
        props: {
            language: {
                default: function () {
                    return 'zh-cn';
                }
            },
            format: {
                type: String,
                default: function () {
                    return 'YYYY-MM-DD';
                }
            },
            exportformat: {
                type: String
            },
            value: {
                required: true,
                default: function () {
                    return '';
                }
            },
            enddate: {
                type: [String, Boolean],
                default: function () {
                    return moment().format('YYYY-MM-DD') + ' 23:59:59';
                }
            },
            mindate: {
                type: [String],
                default: function () {
                    return moment('1900-01-01').format('YYYY-MM-DD') + ' 00:00:00';
                }
            }
        },
        mounted: function () {
            var self = this;
            self.init(self._p_getOptions());
            $(this.$el).find('.date-picker').on('dp.change', function (ev) {
                if (ev.date === null) {
                    return;
                }
                var format = self.exportformat || self.format;
                self.showValue = moment(ev.date).format(format);
                self.changeValue();
            });
            if (this.enddate && this.enddate.length > 0) {
                self.setMaxDate(moment(this.enddate).format(this.format));
            }
            if (this.mindate && this.mindate.length > 0) {
                self.setMinDate(moment(this.mindate).format(this.format));
            }
            this.update(this.myValue);
        },
        methods: {
            getInstance: function (options) {
                var self = this;
                if (!self.instance) {
                    this.init(options);
                    self.instance = $(this.$el).find('.date-picker').data('DateTimePicker');
                }
                return self.instance;
            },
            init: function (options) {
                $(this.$el).find('.date-picker').datetimepicker(options);
            },
            setOptions: function (options) {
                this.getInstance().options(options);
            },
            update: function (val) {
                var self = this;
                var format = this.exportformat || this.format;
                if (!moment(this.myValue, format).isValid()) {
                    self.showValue = val;
                } else {
                    self.showValue = moment(val, self.format).format(self.format);
                }
            },
            setMaxDate: function (val) {
                this.getInstance().maxDate(val);
            },
            setMinDate: function (val) {
                this.getInstance().minDate(val);
            },
            _p_focus: function (e) {
                this.ifocus = true;
                this.$emit('focus', arguments);
            },
            _p_blur: function (e) {
                var self = this;
                this.ifocus = false;
                this.$nextTick(function () {
                    $(self.$el).find('.date-picker').trigger('change');
                    self.changeValue();
                    self.$emit('change', self.myValue);
                });
                this.$emit('blur', arguments);
            },
            _p_click: function (e) {
                $(this.$el).find('.date-picker').data().DateTimePicker.show();
            },
            _p_getOptions: function () {
                return {
                    format: this.format,
                    locale: moment.locale('zh-cn')
                };
            },
            changeValue: function () {
                var self = this;
                var format = this.exportformat || this.format;
                if (!moment(self.myValue, format).isValid()) {
                    this.myValue = '';
                } else
                    this.myValue = moment(self.myValue).format(format);
            }
        },
        watch: {
            'language': function () {
                this.setOptions(this._p_getOptions());
            },
            'format': function () {
                this.setOptions(this._p_getOptions());
            },
            'enddate': function (value) {
                if (value) {
                    value = moment(value).format(this.format);
                    this.setMaxDate(value);
                }
            },
            'mindate': function (value) {
                if (value) {
                    value = moment(value).format(this.format);
                    this.setMinDate(value);
                }
            },
            'value': function (value) {
                this.myValue = value;
                this.update(value);
            },
            'myValue': function (value) {
                this.$emit('input', value);
            }
        }
    };

</script>



// WEBPACK FOOTER //
// datepicker.vue?db3b571e